import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactRoutingModule } from './contact-routing.module';
import { ConfirmMessageComponent } from './confirm-message/confirm-message.component';
import { ContactService } from './contact-services/contact.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { ListMessageComponent } from './list-message/list-message.component';
import { SingleMessageComponent } from './single-message/single-message.component';
import { ContactTempComponent } from './contact-temp/contact-temp.component';
import { MapComponent } from '../components/map/map.component';

@NgModule({
    declarations: [
        ContactFormComponent,
        ConfirmMessageComponent,
        ListMessageComponent,
        SingleMessageComponent,
        ContactTempComponent
    ],
    imports: [
        CommonModule,
        ContactRoutingModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    providers: [
        ContactService
    ],
    exports: [
    ]
})
export class ContactModule { }
